import React, { useState, useEffect } from "react";
import { Box, Flex, HStack, IconButton, useDisclosure, Stack, Image, Link, Text } from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link as ScrollLink } from "react-scroll";
import logotipo from "../assets/logo.png";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [scroll, setScroll] = useState(0);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScroll(offset);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const NavLink = ({ to, children }) => (
    <ScrollLink
      to={to.toLowerCase()}
      smooth={true}
      duration={500}
      spy={true}
      offset={-80}
      onSetActive={() => setActiveSection(to.toLowerCase())}
    >
      <Box
        as="a"
        href="#"
        position="relative"
        fontSize="lg"
        color="black"
        cursor="pointer"
        paddingBottom="4px"
        _hover={{
          textDecoration: 'none',
          _after: { width: '100%' }
        }}
        sx={{
          '&.active': {
            _after: { width: '100%' }
          }
        }}
        _after={{
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: to.toLowerCase() === activeSection ? '100%' : 0,
          height: '3px',
          backgroundColor: '#FFD700',
          transition: 'width 0.3s ease',
        }}
        className={to.toLowerCase() === activeSection ? 'active' : ''}
      >
        {children}
      </Box>
    </ScrollLink>
  );


  const SocialLinks = ({ isMobile = false }) => (
    <HStack spacing={6} {...(isMobile ? { width: "100%", justifyContent: "center", py: 2, mt: 6 } : {})}>
      <Link 
        href="https://instagram.com/cdempilhadeiras" 
        isExternal 
        display="flex" 
        alignItems="center"
        fontWeight="bold"
      >
        <FaInstagram size={isMobile ? 32 : 24} />
        {!isMobile && <Text ml={2} fontWeight="600">@cdempilhadeiras</Text>}
      </Link>
      <Link 
        href="https://wa.me//5581985771555?text=Ol%C3%A1,%20peguei%20o%20contato%20no%20site%20da%20CD%20Empilhadeiras" 
        isExternal 
        display="flex" 
        alignItems="center"
        fontWeight="bold"
      >
        <FaWhatsapp size={isMobile ? 32 : 24} />
        {!isMobile && <Text ml={2} fontWeight="600">81 98577-1555</Text>}
      </Link>
    </HStack>
  );


  return (
    <Box bg="white" px={4} w="100%" py={3} boxShadow={scroll > 10 ? "md" : "none"} position="fixed" top={0} zIndex={1000}>
      <Flex h={20} alignItems="center" justifyContent="center">
        <Flex w={{base: "100%", md: "80%"}} justifyContent="space-between" alignItems="center">
          <Image src={logotipo} alt="Logotipo" height="75px" alignSelf="center" display="flex" />
          
          <IconButton
            size="md"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label="Open Menu"
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />

          <Flex
            direction="column"
            display={{ base: "none", md: "flex" }}
          >
            {/* Social Links - Desktop */}
            <SocialLinks />
            
            {/* Navigation Links - Desktop */}
            <HStack spacing={8} alignItems="center" mt={4}>
              {['Home', 'Sobre', 'Serviços', 'Contato'].map((item) => (
                <NavLink key={item} to={item}>
                  {item}
                </NavLink>
              ))}
            </HStack>
          </Flex>
        </Flex>
      </Flex>

      {/* Mobile Menu */}
      {isOpen ? (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={4}>
            {/* Social Links - Mobile */}
            <SocialLinks isMobile={true} />
            
            {/* Navigation Links - Mobile */}
            {['Home', 'Sobre', 'Serviços', 'Contato'].map((item) => (
              <NavLink key={item} to={item}>
                {item}
              </NavLink>
            ))}
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
};

export default Navbar;